import { PureComponent } from 'react'
import _ from 'lodash'
import { Input } from 'antd'
import { Icon } from '@vzmi/shp_shared_compo'
import InputPicker from '../InputPicker'
import styles from './index.css'

class MassiveMenuSelect extends PureComponent {
  state = {
    isOpen: false,
    filterValue: ''
  }

  getInputPickerLabel = () => {
    const {
      input,
      options
    } = this.props
    const value = _.get(input, 'value', '')
    const label = _.flow(
      () => _.find(options, { value }),
      option => _.get(option, 'label', '')
    )()
    return label
  }

  handleItemMenuSelect = (selectedItemOption) => {
    const target = selectedItemOption.target
    const optionValue = target.getAttribute('data-value')

    this.setState({ isOpen: false })
    this.props.onChange(optionValue)
  }

  // set state to open dropdown or not
  openDropdown = e => {
    this.setState({ isOpen: !this.state.isOpen })
    e.stopPropagation()
  }

  // filter options by search value
  handleSearch = e => {
    const searchValue = e.target.value
    this.setState({ filterValue: searchValue })
  }

  render () {
    const { options, value, ...restProps } = this.props
    const dataRole = restProps['data-role']
    const { isOpen, filterValue } = this.state

    if (!options || !options.length) {
      return null
    }

    // get last item for footer
    const { value: lastOptVal, label: lastOptLabel } = options[options.length - 1]
    const isLastActive = value === lastOptVal

    return (
      <>
        <div
          className={styles.MassiveMenuSelect}
          data-role={dataRole}
        >
          <InputPicker
            value={this.getInputPickerLabel()}
            active={isOpen}
            onClick={this.openDropdown}
            className={styles.MassiveMenuSelect}
          />
          {
            isOpen && (
              <div
                className={`y-menus y-menu-select ${styles.MassiveMenuSelectPopup}`}
              >
                <div>
                  <div className='y-menu-container'>
                    <div
                      className={`y-menu-filter ${styles.MassiveMenuSelectFilter}`}
                    >
                      <Input
                        addonBefore={(
                          <Icon
                            name='search'
                            size={14}
                          />
                        )}
                        autoComplete='off'
                        type='text'
                        value={filterValue}
                        placeholder='搜尋關鍵字'
                        onChange={this.handleSearch}
                      />
                    </div>
                    <ul
                      className='y-menu'
                    >
                      {
                        options
                          // pop last item to footer
                          .slice(0, -1)
                          .filter(option => {
                            const { label } = option
                            // filter options by search value case-insensitively
                            return label.toLowerCase().includes(filterValue.toLowerCase())
                          })
                          .map(option => {
                            const {
                              value: optVal,
                              label: optLabel,
                              key: optKey
                            } = option
                            const isActive = value === optVal

                            return (
                              <li
                                key={optKey}
                                data-role={`${dataRole}-item`}
                                data-value={optVal}
                                onClick={this.handleItemMenuSelect}
                                className={`y-menu-item${isActive ? ' y-menu-item-active' : ''}`}
                              >
                                {optLabel}
                              </li>
                            )
                          })
                      }
                    </ul>
                    <div className={styles.MassiveMenuSelectFooter}>
                      <span
                        data-role={`${dataRole}-item`}
                        data-value={lastOptVal}
                        onClick={this.handleItemMenuSelect}
                        className={`y-menu-item${isLastActive ? ' y-menu-item-active' : ''}`}
                      >
                        {lastOptLabel}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </>
    )
  }
}

export default MassiveMenuSelect
